import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CaretLeft, CaretRight } from "@phosphor-icons/react";

const SLIDES = [
  {
    eyebrow: "Auto rezerves daļas · Eļļas · Ķīmija",
    title: "Eļļas un rezerves daļas jūsu biznesam",
    text: "ENEOS un ORLEN eļļas no 1L līdz 205L mucai, PHILIPS spuldzes, autoķīmija un servisa preces. Apjoma cenas — piegāde visā Latvijā 1–2 dienās.",
    img: "https://images.unsplash.com/photo-1696441567908-6a04d49e1350?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1600",
    cta: { label: "Skatīt katalogu", to: "/katalogs" },
    cta2: { label: "Pieprasīt B2B piedāvājumu", to: "/piedavajums" },
  },
  {
    eyebrow: "Lauksaimniekiem un autoparkiem",
    title: "Eļļas mucās — līdz pat 10% izdevīgāk",
    text: "Hidraulikas, transmisijas un motoreļļas 205L mucās un 1000L konteineros. Piegāde ar autoiekrāvēju līdz jūsu saimniecībai.",
    img: "https://images.unsplash.com/photo-1567016958860-87d898933af1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1600",
    cta: { label: "Eļļas mucās", to: "/katalogs?category=ella" },
    cta2: { label: "B2B sadarbība", to: "/b2b" },
  },
  {
    eyebrow: "Auto servisiem",
    title: "Ātrā pasūtīšana pēc artikula numura",
    text: "Ievadiet artikulus un daudzumus sarakstā — viss grozā ar vienu klikšķi. Apmaksa ar rēķinu un piegāde jau nākamajā dienā.",
    img: "https://images.unsplash.com/photo-1487754180451-c456f719a1fc?auto=format&fit=crop&q=70&w=1600",
    cta: { label: "Izmēģināt ātro pasūtīšanu", to: "/atra-pasutisana" },
    cta2: { label: "Kļūt par B2B klientu", to: "/b2b" },
  },
];

export const HeroCarousel = () => {
  const [active, setActive] = useState(0);
  const next = useCallback(() => setActive((a) => (a + 1) % SLIDES.length), []);
  const prev = () => setActive((a) => (a - 1 + SLIDES.length) % SLIDES.length);

  useEffect(() => {
    const t = setInterval(next, 6000);
    return () => clearInterval(t);
  }, [next, active]);

  return (
    <section className="mx-auto max-w-7xl px-4 pt-6">
      <div data-testid="hero-carousel" className="relative overflow-hidden rounded-3xl bg-[#0c1a28] text-white">
        {SLIDES.map((s, i) => (
          <div key={i} data-testid={`hero-slide-${i}`} aria-hidden={i !== active}
            className={`transition-opacity duration-700 ${i === active ? "relative opacity-100" : "absolute inset-0 opacity-0 pointer-events-none"}`}>
            <img src={s.img} alt={s.title} className="absolute inset-0 h-full w-full object-cover opacity-45" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0c1a28]/90 via-[#0c1a28]/40 to-transparent" />
            <div className="relative px-6 py-14 md:px-14 md:py-24 max-w-3xl">
              <p className="text-xs font-bold tracking-[0.3em] uppercase text-[#8FC1EA]">{s.eyebrow}</p>
              <h1 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight">{s.title}</h1>
              <p className="mt-4 max-w-xl text-sm md:text-base text-slate-200">{s.text}</p>
              <div className="mt-7 flex flex-wrap gap-3">
                <Link to={s.cta.to} data-testid={`hero-cta-${i}`} className="btn-industrial inline-flex items-center gap-2 bg-[#2E86D1] px-6 py-3.5 text-sm font-semibold text-white hover:bg-[#1F6DB2]">
                  {s.cta.label} <ArrowRight size={18} />
                </Link>
                <Link to={s.cta2.to} className="btn-industrial inline-flex items-center gap-2 border border-white/70 px-6 py-3.5 text-sm font-semibold hover:bg-white hover:text-[#0c1a28]">
                  {s.cta2.label}
                </Link>
              </div>
            </div>
          </div>
        ))}

        <button data-testid="hero-prev-btn" aria-label="Iepriekšējais banneris" onClick={prev}
          className="btn-industrial absolute right-16 top-6 md:top-auto md:bottom-8 flex h-10 w-10 items-center justify-center rounded-full bg-white/15 text-white backdrop-blur hover:bg-[#2E86D1]">
          <CaretLeft size={18} />
        </button>
        <button data-testid="hero-next-btn" aria-label="Nākamais banneris" onClick={next}
          className="btn-industrial absolute right-4 top-6 md:top-auto md:bottom-8 flex h-10 w-10 items-center justify-center rounded-full bg-white/15 text-white backdrop-blur hover:bg-[#2E86D1]">
          <CaretRight size={18} />
        </button>

        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 md:left-14 md:translate-x-0 md:bottom-8">
          {SLIDES.map((_, i) => (
            <button key={i} data-testid={`hero-dot-${i}`} aria-label={`Banneris ${i + 1}`} onClick={() => setActive(i)}
              className={`h-2.5 rounded-full transition-all duration-300 ${i === active ? "w-8 bg-white" : "w-2.5 bg-white/40 hover:bg-white/70"}`} />
          ))}
        </div>
      </div>
    </section>
  );
};
